import Axios, { type AxiosInstance } from 'axios'
import { type CommonHeaders, getCommonHeaders } from '../client/utilities.client-helper'
import { isProduction } from './environment'

let axios: AxiosInstance

// eslint-disable-next-line @typescript-eslint/space-before-function-paren
function configureAxios() {
  if (isProduction()) {
    return Axios.create({
      baseURL: 'https://api.justo.cloud/op-location-manager/'
    })
  }
  return Axios.create({
    baseURL: 'https://stag.justo.cloud/op-location-manager/'
  })
}

// eslint-disable-next-line @typescript-eslint/space-before-function-paren
function getAxiosInstance(): AxiosInstance {
  if (!axios) {
    axios = configureAxios()
    axios.interceptors.request.use(async (config) => {
      const headers: CommonHeaders = await getCommonHeaders()
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      Object.keys(headers).forEach((e) => config.headers.set(e, headers[e]))
      console.log('Config', config)
      return config
    })
  }

  return axios
}

export const msLocationAxiosInstance = getAxiosInstance
